import React, { useEffect, useState } from "react";
import {
  getKnockoutScheduleRoundData,
  updateKnockoutMatchWinner
} from "../../../../Config/API/knockout-schedule";
import Loader from "../../../../common/cards/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { Bracket } from "react-brackets";
import "./knockout-schedule.css";
import Swal from "sweetalert2";
import CustomSeed from "./CustomSeed";

function KnockoutMatches() {
  const [scheduleData, setScheduleData] = useState(null);
  const [fetchingData, setFetchingData] = useState(false);

  const navigate = useNavigate();
  const params = useParams();
  const eventId = params?.id;

  const getScheduleData = async () => {
    setFetchingData(true);
    const response = await getKnockoutScheduleRoundData({ eventId });
    const result = await response.json();
    if (result?.type === "success") {
      const rounds = result?.data?.rounds?.map((round) => {
        return {
          seeds: round?.matchesSlot,
          title: round?.roundNo,
          _id: round?._id
        };
      });
      setScheduleData({ ...result?.data, rounds });
    } else {
      navigate(-1);
    }
    setFetchingData(false);
  };

  const updateWinner = async (data) => {
    const response = await updateKnockoutMatchWinner(data);
    const result = await response.json();
    if (result?.knockoutEvent) {
      const rounds = result?.knockoutEvent?.rounds?.map((round) => {
        return {
          seeds: round?.matchesSlot,
          title: round?.roundNo,
          _id: round?._id
        };
      });

      // update rounds data
      setScheduleData((prev) => ({
        ...prev,
        rounds
      }));
    }
  };

  const chooseMatchWinner = async ({ winner, opponent, data }) => {
    if (winner?._id && opponent?._id) {
      Swal.fire({
        icon: "question",
        title: "Choose winner, Round 1",
        html: `
    Are you sure you want to choose <b>${winner?.name}</b> as a winner against <b>${opponent?.name}</b> ?
  `,
        showCancelButton: true,
        confirmButtonText: "Choose Winnter"
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const payload = {
            eventId: eventId,
            currentRound: Number(data?.roundIndex) + 1,
            matchId: data?._id,
            winningTeamId: winner?._id
          };
          updateWinner(payload);
        }
      });
    }
  };

  useEffect(() => {
    getScheduleData();
    return () => {
      setScheduleData(null);
    };
  }, []);

  if (fetchingData) {
    return <Loader fullpage={true} />;
  }

  return (
    <div className="mt-5">
      <Bracket
        rounds={scheduleData?.rounds || []}
        roundTitleComponent={(title, roundIndex) => {
          return (
            <div key={roundIndex} style={{ textAlign: "center" }}>
              Round {title}
            </div>
          );
        }}
        renderSeedComponent={({ seed, breakpoint, roundIndex }) => (
          <CustomSeed
            seed={seed}
            roundIndex={roundIndex}
            breakpoint={breakpoint}
            chooseMatchWinner={chooseMatchWinner}
          />
        )}
      />
    </div>
  );
}

export default KnockoutMatches;
